export default "__VITE_ASSET__nL2_BqoT__"